/* globals h337 */
import * as d3 from 'd3';

export default class Heatmap {

  constructor(element, Services, showLayers, filters) {
    this.element = element;
    this.Services = Services;
    this.projectId = 1109;
    this.url = 'http://www.mtgec.jp/shop/default.aspx';
    this.heatmapScroll = undefined;
    this.heatmapClicks = undefined;
    this.heatmapMovements = undefined;
    this.currentScroll = 0;
    this.windowWidth = $(document).width(); // eslint-disable-line
    this.showLayers = showLayers;
    this.filters = filters;

    this.initialize();
  }

  initialize() {
    const container = this.element;
    const scrollContainer = $(this.element).parent().find('.heatmap-scroll-container');

    // const $iframeContainer = $('<div class="iframe-container"></div>');
    // const $iframe = $(`<iframe src="${this.url}" scrolling="no"></iframe>`);
    // $($iframeContainer).append($iframe);
    // $(container).prepend($iframeContainer);
    // this.$iframe = $iframe;
    // this.$iframeContainer = $iframeContainer;

    const heatmapScroll = h337.create({
      container: scrollContainer[0],
    });
    this.heatmapScroll = heatmapScroll;
    scrollContainer.css('position', 'absolute');

    const heatmapClicks = h337.create({
      container: container,
      onExtremaChange: changes => {
        this.updateControls(changes);
      }
    });
    this.heatmapClicks = heatmapClicks;

    function handleError(a, b, error) {
      console.error(a, b, error);
    }

    const urls = {
      // heatmap: '/assets/mtgec-heatmap.json',
      // maxScrollmap: '/assets/mtgec-max-scrollmap.json',
      // scrollmap: '/assets/mtgec-scrollmap.json',
      heatmap: 'https://s3-ap-northeast-1.amazonaws.com/visualizer-captures/sites/mtgec/heatmap/2017/04/mtgec-heatmap.json',
      maxScrollmap: 'https://s3-ap-northeast-1.amazonaws.com/visualizer-captures/sites/mtgec/heatmap/2017/04/mtgec-max-scrollmap.json',
      scrollmap: 'https://s3-ap-northeast-1.amazonaws.com/visualizer-captures/sites/mtgec/heatmap/2017/04/mtgec-scrollmap.json'
    };

    // TODO: change this url to come from S3 or so
    $.getJSON(urls.heatmap, {})
      .error(handleError)
      .success(heatmap => {
        this.heatmap = heatmap;
        _.each(this.heatmap, d => {
          d.x = d.x + this.windowWidth / 2;
        });

        // $.getJSON('/assets/mtgec-scrollmap.json', {})
        // .error(handleError)
        // .success(scrollmap => {
        //   this.scrollmap = scrollmap;

        $.getJSON(urls.maxScrollmap, {})
          .error(handleError)
          .success(maxScrollmap => {
            this.maxScrollmap = maxScrollmap;
            const uniqSessions = _.uniq(_.map(this.heatmap, '_usid'));
            this.uniqSessions = uniqSessions;
            console.log('heatmap length: ', this.heatmap.length, 'uniq: ', uniqSessions.length);

            //.text(`${uniqSessions}セッションのデータを表示してます`);
            $(this.element).find('canvas').css({opacity: 0.9});
            this.createHeatmap();
          });
      // });
      });
  }

  updateControls(changes) {
    const $controls = $(this.element).parent().find('.controls');
    $controls.html('');

    const createdAts = _.map(this.currentHeatmapData, d => moment(d.created_at).toDate());
    const min = moment(_.min(createdAts)).format('YYYY-MM-DD');
    const max = moment(_.max(createdAts)).format('YYYY-MM-DD');

    $controls.append(
      $(`
      <div>
      期間：${min} ~ ${max}
      </div>`)
    );

    $controls.append('<div class="how-many"></div>');
    $controls.find('.how-many').text(`${this.uniqSessions.length}のPCセッションのうちの注目度`);
    _.each([1, 0.85, 0.55, 0.25], k => {
      const clicks = Math.round(k * 100 / 15);
      $controls.append(
        $(`
        <div>
          <span style="opacity: 0.8; margin-right: 10px; background-color: ${changes.gradient[k]}; display: inline-block; width: 15px; height: 15px;"></span>
          ${clicks}%
        </div>`)
      );
    });
  }

  redraw() {
    this.createHeatmap();
  }

  createScrollPercentages() {
    d3.select(this.element)
      .selectAll('div.scroll-percentage')
      .data(this.maxScrollmap)
      .enter()
      .append('div')
      .attr('class', 'scroll-percentage')
      .text(d => Math.round(d.value * 100) + '%')
      .style('position', 'absolute')
      .style('color', 'black')
      .style('top', d => d.y + 'px')
      .style('left', '170px');

  }

  createHeatmap(type) {
    const heatmapData = _.chain(this.heatmap)
      .reject(d => {
        if(!this.showLayers.clicks) {
          return d.is_click;
        }
        return false;
      })
      .reject(d => {
        if(!this.showLayers.mouseMovement) {
          return !d.is_click;
        }
        return false;
      })
      .filter(d => {
        if(this.filters.convertedUsers) {
          return d.cv_user;
        }
        return true;
      })
      .filter(d => {
        if(this.filters.newUsers) {
          return d.segment_new;
        }
        return true;
      })
      .value();
    this.currentHeatmapData = heatmapData;

    const uniqSessions = _.uniq(_.map(this.currentHeatmapData, '_usid'));
    this.uniqSessions = uniqSessions;

    // this.heatmapClicks.clear();
    this.heatmapClicks.setData({
      max: this.uniqSessions.length / 15,
      data: heatmapData
    });

    this.heatmapScroll.setData({
      max: 2,
      data: this.maxScrollmap
    });

    this.createScrollPercentages();
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.heatmap/heatmap.js